module.exports = __webpack_public_path__ + "i.no2.b8b0a44e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/i.no2.jpg
// module id = qPii
// module chunks = 0